module.exports = {
  // ENV: 'dev',
  ENV: 'daoyi',
  // ENV: 'study',
  // ENV: 'hm'
}